
var app = angular.module('directives.masterpassAuthForm', []);

require('./directives/masterpassAuthForm.js');
require('./stylesheets/masterpassAuthForm.scss');
require('./templates/index.html');

module.exports = app;



/*****************
 ** WEBPACK FOOTER
 ** ./app/directives/masterpassAuthForm/index.js
 ** module id = 181
 ** module chunks = 1
 **/